import { QueryClient } from '@tanstack/react-query';
import { ApiError } from '../shared/api/problem';

/** Retry network hiccups and server errors once; never retry a 4xx (the request itself is wrong). */
function shouldRetry(failureCount: number, error: unknown): boolean {
  if (error instanceof ApiError && error.problem.status >= 400 && error.problem.status < 500) return false;
  return failureCount < 1;
}

export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: { staleTime: 10_000, retry: shouldRetry, refetchOnWindowFocus: true },
      mutations: { retry: false },
    },
  });
}
